import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { CreateJobRequest, IAllJobsResponse, IJob, IJobStatsResponse } from "../models/Job";
// import { ISetting, ISettingsResponse } from "../models/Setting";

export default function usePin() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  // true/ false and guid for user that its for
  const validatePin = useMutation(
    (body: any) => post(`/user/pin`, body),
  );

  // Generate pin for user, if username is set then it will generate a pin for that user
  // else it will generate a pin for the authed user
  const generatePin = useMutation(
    (body: any) => post(`/user/pin/generate`, body),
  );

  return {
    validatePin,
    generatePin
  };
}
